// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"4151f21d","55":"e3a9fe42","126":"a89e6f47","137":"5af58523","535":"84321194","655":"c92a3dbb","686":"2706adfe","892":"02c12441","950":"e49302d6"}[chunkId] + ".chunk.js";
};